import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.data = {};
axios.defaults.headers.common.Accept = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// export const requestInstance =  axios.create();
export const requestInstance = axios.create({
  withCredentials: true,
});


requestInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    const errorStatus = error?.response?.status;

    if (errorStatus >= 500) {
      toast.error(error.response?.data?.errors?.message);
    }

    return Promise.reject(error);
  }
);
requestInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {

      document.cookie = "token=; path=/; max-age=0";
      window.location.href = "/login";
      return Promise.reject(error);
    }

    if (error?.response?.status === 422) {
      handleError(error);
    }

    const page = window.location.pathname;
    if (
      ![
        "/trips",
        "personel",
        "/trip-management",
        "/trip-management-map",
        "/trip-map",
        "/consignment-manage-operation",
        "/barcode",
        "/Collect-management-map",
        "/delivery-management-map",
        "/delivery-management",
        "/order-management",
      ].includes(page)
    ) {
      if (error?.response?.status >= 500) {
        handleError(error);
        return Promise.reject(error);
      }
    }

    handleError(error);
    return Promise.reject(error);
  }
);

export const mainService = requestInstance;
export default requestInstance;

export function handleError(error: any) {
  if (Array.isArray(error?.response?.data?.messages)) {
    for (let err of error?.response?.data?.messages) {
      toast.error(err?.message);
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }
}